'use client'
import Link from 'next/link'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import blogPosts from '../../data/blog-posts.json'

export default function LatestBlogPosts() {
    const pathname = usePathname()
    if (pathname === '/blog') return null

    const posts = blogPosts.slice(0, 3)

    return (
        <section className="section" style={{ background: 'var(--gray-100)' }}>
            <div className="container">
                <div className="section-head" style={{ marginBottom: 'var(--spacing-md)' }}>
                    <span className="section-eyebrow">Blog</span>
                    <h2>Latest from Our Blog</h2>
                </div>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                    gap: 'var(--spacing-md)',
                    maxWidth: '1100px',
                    margin: '0 auto'
                }}>
                    {posts.map(post => (
                        <article key={post.id} className="card card-hover" style={{
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <Link
                                href={`/blog/${post.slug}`}
                                style={{
                                    textDecoration: 'none',
                                    color: 'inherit',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1
                                }}
                            >
                                <div style={{ position: 'relative', height: '180px', margin: '0.6rem 0.6rem 0', borderRadius: 'var(--radius-md, 12px)' }}>
                                    <Image
                                        src={post.image}
                                        alt={post.title}
                                        fill
                                        quality={55}
                                        sizes="(max-width: 768px) 100vw, 33vw"
                                        style={{ objectFit: 'cover', borderRadius: '12px' }}
                                    />
                                </div>
                                <div style={{
                                    padding: 'var(--spacing-md)',
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    <div style={{
                                        fontSize: '0.85rem',
                                        color: 'var(--primary-light)',
                                        fontWeight: 700,
                                        marginBottom: '0.4rem'
                                    }}>
                                        {post.date}
                                    </div>
                                    <h3 style={{ fontSize: '1.15rem', marginBottom: '0.5rem' }}>
                                        {post.title}
                                    </h3>
                                    <p style={{
                                        fontSize: '0.92rem',
                                        color: 'var(--gray-500)',
                                        marginBottom: '0.75rem',
                                        flex: 1
                                    }}>
                                        {post.excerpt}
                                    </p>
                                    <span style={{
                                        color: 'var(--primary)',
                                        fontWeight: 700,
                                        fontSize: '0.9rem'
                                    }}>
                                        Read Guide →
                                    </span>
                                </div>
                            </Link>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}
